import { createCrudActions } from '../utils/crudGenerator';

const formatHotelchains = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchHotelchains,
    create: createHotelchain,
    update: updateHotelchain,
    delete: deleteHotelchains
} = createCrudActions('HOTELCHAIN', "Cadena", formatHotelchains);